const globalCSS = `
@layer theme, base, mui, components, utilities;

::-moz-selection { background: var(--tuna-palette-action-selected); }
::selection { background: var(--tuna-palette-action-selected); }

body, html {
  background-color: var(--tuna-palette-background-default);
  --background-color: var(--tuna-palette-background-default);
  font-family: var(--tuna-typography-fontFamily);
}

h1, h2, h3, h4, h5, h6 {
  color: var(--tuna-palette-text-primary);
}

p {
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: var(--tuna-typography-body1-fontWeight);
  line-height: var(--tuna-typography-body1-lineHeight);
  letter-spacing: var(--tuna-typography-body1-letterSpacing);
}

h1 {
  margin-top: var(--tuna-spacing-2);
  margin-bottom: var(--tuna-spacing-1);
  font-weight: var(--tuna-typography-heading-fontWeight);
  font-size: var(--tuna-typography-h1-fontSize);
  line-height: var(--tuna-typography-h1-lineHeight);
}

h2 {
  margin-top: var(--tuna-spacing-2);
  margin-bottom: var(--tuna-spacing-1);
  font-weight: var(--tuna-typography-heading-fontWeight);
  font-size: var(--tuna-typography-h2-fontSize);
  line-height: var(--tuna-typography-h2-lineHeight);
}

h3 {
  margin-top: var(--tuna-spacing-2);
  margin-bottom: var(--tuna-spacing-1);
  font-weight: var(--tuna-typography-heading-fontWeight);
  font-size: var(--tuna-typography-h3-fontSize);
  line-height: var(--tuna-typography-h3-lineHeight);
}

h4 {
  margin-top: var(--tuna-spacing-2);
  margin-bottom: var(--tuna-spacing-1);
  font-weight: var(--tuna-typography-heading-fontWeight);
  font-size: var(--tuna-typography-h4-fontSize);
  line-height: var(--tuna-typography-h4-lineHeight);
}

h5 {
  margin-top: var(--tuna-spacing-2);
  margin-bottom: var(--tuna-spacing-1);
  font-weight: var(--tuna-typography-heading-fontWeight);
  font-size: var(--tuna-typography-h5-fontSize);
  line-height: var(--tuna-typography-h5-lineHeight);
}

h6 {
  margin-top: var(--tuna-spacing-1);
  margin-bottom: var(--tuna-spacing-1);
  font-weight: var(--tuna-typography-heading-fontWeight);
  font-size: var(--tuna-typography-h6-fontSize);
  line-height: var(--tuna-typography-h6-lineHeight);
}
`

export const TunaGlobalStyles = () => <style dangerouslySetInnerHTML={{ __html: globalCSS }} />

export default TunaGlobalStyles
